import styled from 'styled-components';
import theme from '../styles/theme';
import Status from '../types/enum/Status';
import Button from './Button';
import FlexBox, { FlexGrow } from './FlexBox';
import { ClickableIcon } from './Icon';
import Modal from './Modal';
import { RightAlign } from './UtilsComponents';
import { Icon as MuiIcon } from '@mui/material';

type CourseDropModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  title: string;
  description: any;
  hideCancel?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  icon?: string | null;
  iconColor?: string;
  isDisabled?: boolean;
};
const Title = styled.div`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 0px 24px;
  width: 318px;
  background: rgba(236, 197, 198, 0.1);
  border-radius: 4px;
  // margin: 24px 0px;
`;
const Desc = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  padding: 16px 0;
  display: flex;
  align-items: center;
  // text-align: center;
  margin: 0px 10px;
`;

const ConfirmModal = ({
  isOpen,
  setOpen,
  confirmFunction,
  title,
  description,
  hideCancel = false,
  confirmLabel = "Yes",
  cancelLabel = "No",
  icon = "warning_amber_rounded",
  iconColor = "#f5a623",
  isDisabled = false,
}: CourseDropModalProps): JSX.Element => {
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={!isDisabled ? setOpen : ()=>{}}
        customStyle={{
          content: {
            maxWidth: "1000px",
            padding: 0,
            background: "#090d20",
            border: "1px solid #2D416C",
            boxShadow: "0px 4px 16px rgba(0,0,0)",
            borderRadius: "8px",
            marginTop: 100,
          },
        }}>
        <FlexBox style={{ height: '64px',  margin: "10px 20px 10px 20px" }}>
          <FlexGrow>
            <Title>{title}</Title>
          </FlexGrow>
          <ClickableIcon name="times" onClick={() => setOpen(false)} />
        </FlexBox>
        <FlexBox style={{margin:"0px 20px 0px 20px"}}>
          <Flex>
            <Desc>
              {icon && (
                <MuiIcon
                  sx={{
                    color: iconColor,
                    fontSize: '32px',
                    marginRight: '12px',
                    flexShrink: 0,
                  }}>
                  {icon}
                </MuiIcon>
              )}
              <span>{description}</span>
            </Desc>
          </Flex>
        </FlexBox>
        <FlexBox justify="end" style={{padding:20}}>
          {!hideCancel && (
            <FlexGrow style={{ flexGrow: '0' }}>
              <Button
                disabled={isDisabled}
                style={{
                  width: '151px',
                  height: '48px',
                  padding: '13px 12px',
                }}
                isOutline
                onClick={() => {
                  setOpen(false);
                }}
                status={Status.default}>
                {cancelLabel}
              </Button>
            </FlexGrow>
          )}
          <FlexGrow style={{ flexGrow: '0' }}>
            <Button
              style={{
                width: '151px',
                height: '48px',
                padding: '13px 12px',
              }}
              status={Status.button}
              onClick={() => {
                confirmFunction();
              }}
              disabled={isDisabled}>
              {confirmLabel}
            </Button>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default ConfirmModal;
